<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="20000" :color="colorSnack">
      <div class="d-flex justify-space-around">
        <span class="mx-2"> {{ mensajeSnackbar }} </span>
        <v-btn text dark @click="snackbar = !snackbar"> Cerrar </v-btn>
      </div>
    </v-snackbar>

    <v-stepper non-linear v-model="paso">
      <v-stepper-header>
        <v-stepper-step editable step="1"> Nuevo Proyecto </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="2"> Articulos </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="3"> Archivos </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="4"> Finalizar </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <!-- PASO NUMERO 1 -->
        <v-stepper-content step="1">
          <v-card class="mb-12" color="grey lighten-4">
            <v-card-title>
              <h3>Datos del proyecto</h3>
                &ensp;
              <v-checkbox label="SERVICIO"  v-model="tipo" dense  filled class="ma- mx- pa-0" hide-details />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field label="Vendedor" filled dense v-model="vendedorSeleccionado" readonly />
                </v-col>

                <v-col cols="12" sm="12" md="6" class="py-0">
                  <v-autocomplete
                    label="Cliente"
                    filled
                    dense
                    v-model="clienteSeleccionado"
                    :items="clientes"
                    item-text="NOMBRE"
                    item-value="NOMBRE"
                    return-object
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="py-0">
                  <v-menu
                    v-model="modalFecha"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        filled
                        dense
                        light
                        v-model="fechaSeleccionada"
                        label="Fecha a entregar"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                  <v-date-picker
                    v-model="fechaSeleccionada"
                    @input="modalFecha = false"
                    :min="minFecha[0]"
                  >
                  </v-date-picker>
                </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-text-field label="Folio (Opcional)" v-model="folio" dense filled />
                </v-col>

                <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-text-field label="Factura (Opcional)" filled dense v-model="factura" />
                </v-col>

                <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-text-field label="Costo (Opcional)" v-model="costo" min="0" prefix="$" type="number" dense filled />
                </v-col>

                <v-col cols="12" sm="12" md="3" class="py-0">
                  <v-text-field label="Venta (Opcional)" v-model="venta" min="0" prefix="$" type="number" dense filled />
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-around">
            <v-btn text @click="cerrar"> Cancelar </v-btn>
            <v-btn color="primary" @click="paso = 2"> Continuar </v-btn>
          </div>
        </v-stepper-content>
        <!-- FIN PASO NUMERO 1 -->

        <!-- PASO NUMERO 2 -->
        <v-stepper-content step="2">
          <v-card class="mb-12" color="grey lighten-3">
            <span class="text-h5 ma-2 font-weight-bold">Agregar Articulos</span>

            <Articulos
              @setArticulos="setArticulos"
              @archivoExcel="setArchivoExcel"
            />
          </v-card>
          <div class="d-flex justify-space-around">
            <v-btn text @click="paso = 1"> Regresar </v-btn>
            <v-btn color="primary" @click="paso = 3"> Continuar </v-btn>
          </div>
        </v-stepper-content>
        <!-- FIN PASO NUMERO 2 -->

        <!-- PASO NUMERO 3 -->
        <v-stepper-content step="3">
          <v-card class="mb-12" color="grey lighten-3">
            <v-card-title>Adjuntar Archivos (Opcional)</v-card-title>

            <v-file-input
              v-model="archivos"
              class="pa-4" multiple outlined 
              @change="agregarArchivo(archivos)" type="file"
            >
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>

            <div v-if="archivos[0]">
              <!-- PANEL MOSTRAR IMAGENES -->
              <span v-if="imagenes[0]" class="mx-3"
                >IMAGEN/es
                <div class="mx-3 d-flex justify-start">
                  <v-img
                    v-for="url in imagenes"
                    :key="url"
                    :src="url"
                    alt=""
                    style="max-width: 100px"
                  />
                </div>
              </span>
              <!-- FIN PANEL IMAGENES -->

              <!-- PANEL ARCHIVOS WORD -->
              <span v-if="word[0]" class="mx-3"
                >WORD/s
                <div class="mx-3 d-flex justify-start">
                  <div
                    class="ma-3"
                    v-for="archword in word"
                    :key="archword.name"
                    style="max-width: 120px"
                  >
                    <v-card>
                      <v-card-title>
                        <v-img
                          src="../../assets/word.png"
                          alt=""
                          class="ma-1"
                        />
                      </v-card-title>

                      <v-card-text class="blue lighten-1 pt-3 alturaTexto">
                        <span
                          class="white--text font-weight-bold tamanoLetra"
                          >{{ archword.name }}</span
                        >
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </span>
              <!-- FIN ARCHIVOS WORD -->

              <!-- PANEL ARCHIVOS EXCEL -->
              <span v-if="excel[0]" class="mx-3"
                >EXCEL/s
                <div class="mx-3 d-flex justify-start">
                  <div
                    class="ma-3"
                    v-for="archexcel in excel"
                    :key="archexcel.name"
                    style="max-width: 120px"
                  >
                    <v-card>
                      <v-card-title>
                        <v-img src="../../assets/excel.png" alt="" />
                      </v-card-title>
                      <v-card-text class="green lighten-1 pt-3 alturaTexto">
                        <span
                          class="white--text font-weight-bold tamanoLetra"
                          >{{ archexcel.name }}</span
                        >
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </span>
              <!-- FIN ARCHIVOS EXCEL -->

              <!-- PANEL ARCHIVOS PDF -->
              <span v-if="pdf[0]" class="mx-3"
                >PDF/s
                <div class="mx-3 d-flex justify-start">
                  <div
                    class="ma-3"
                    v-for="archpdf in pdf"
                    :key="archpdf.name"
                    style="max-width: 120px"
                  >
                    <v-card>
                      <v-card-title>
                        <v-img src="../../assets/pdf.png" alt="" />
                      </v-card-title>
                      <v-card-text class="red lighten-1 pt-3 alturaTexto">
                        <span class="white--text font-weight-bold tamanoLetra">
                          {{ archpdf.name }}
                        </span>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </span>
              <!-- FIN ARCHIVOS PDF -->

              <!-- PANEL ARCHIVOS PDF -->
              <span v-if="def[0]" class="mx-3"
                >Archivo/s
                <div class="mx-3 d-flex justify-start">
                  <div
                    class="ma-3"
                    v-for="archpdf in def"
                    :key="archpdf.name"
                    style="max-width: 120px"
                  >
                    <v-card>
                      <v-card-title>
                        <v-img src="../../assets/default.png" alt="" />
                      </v-card-title>
                      <v-card-text class="grey darken-1 pt-3 alturaTexto">
                        <span class="white--text font-weight-bold tamanoLetra">
                          {{ archpdf.name }}
                        </span>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </span>
              <!-- FIN ARCHIVOS default -->
            </div>
          </v-card>
          <div class="d-flex justify-space-around">
            <v-btn text @click="paso = 2"> Regresar </v-btn>
            <v-btn color="primary" @click="paso = 4"> Continuar </v-btn>
          </div>
        </v-stepper-content>
        <!-- FIN PASO NUMERO 3 -->

        <!-- PASO NUMERO 4 -->
        <v-stepper-content step="4">
          <v-card class="mb-12" color="grey lighten-3">
            <v-card-title class="mx-3">Resumen</v-card-title>

            <v-card-text>
              <v-list
                v-if="fechaSeleccionada ||
                  clienteSeleccionado ||
                  folio ||
                  articulos[0] ||
                  archivos[0] ||
                  archivoExcel"
              >
                <div class="d-flex justify-space-around">
              <v-row>
                  <v-col cols="12" sm="12" md="2" v-if="folio">
                    <span class="mx-3 font-weight-bold"> Folio: </span>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ folio }}
                        </v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" sm="12" md="2" v-if="vendedorSeleccionado">
                    <span class="mx-3 font-weight-bold"> Vendedor: </span>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ vendedorSeleccionado }}
                        </v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" sm="12" md="2" v-if="clienteSeleccionado">
                    <span class="mx-3 font-weight-bold"> Cliente: </span>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{
                            clienteSeleccionado.NOMBRE
                          }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" sm="12" md="2" v-if="fechaSeleccionada">
                    <span class="mx-3 font-weight-bold">
                      Fecha de entrega:
                    </span>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle>{{
                          fechaSeleccionada
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" sm="12" md="2" >
                    <span class="mx-3 font-weight-bold"> Excel Producto: </span>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle>{{
                          archivoExcel ? archivoExcel.name : 'No Asignado.'
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <!-- <v-col cols="12" sm="12" md="2" v-if="articulos[0]"> -->
                  <v-col cols="12" sm="12" md="2" v-if="costo != null && costo != 0">
                    <span class="mx-3 font-weight-bold"> Costo Proyecto: </span>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          <!-- ${{ getCosto }} -->
                          ${{costo}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="2" v-if="venta != null && venta != 0">
                    <span class="mx-3 font-weight-bold"> Venta Proyecto: </span>
                    <v-list-item dense>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          <!-- ${{ getCosto }} -->
                          ${{venta}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
              </v-row>
                </div>

                <div v-if="articulos[0]">
                  <span class="mx-3 font-weight-bold"> Productos: </span>
                  <v-list-item
                    dense
                    v-for="articulo in articulos"
                    :key="articulo.ARTICULO_ID"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >{{ cortarString(articulo.NOMBRE, 100) }}
                        <span class="d-flex font-weight-bold text-body-2">
                          COSTO: ${{ articulo.COSTO }}</span
                        >
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>

                <div v-if="archivos[0]">
                  <span class="mx-3 pt-3 font-weight-bold">
                    Archivos del proyecto:
                  </span>
                  <v-list-item
                    dense
                    v-for="archivo in archivos"
                    :key="archivo.name"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle>{{
                        archivo.name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list>

              <v-alert
                v-else
                class="my-2"
                :value="true"
                type="info"
                color="warning lighten-1"
              >
                Regresa para agregar informacion.
              </v-alert>
            </v-card-text>
          </v-card>
          <div class="d-flex justify-space-around">
            <v-btn text @click="paso = 3"> Regresar </v-btn>
            <v-btn :loading="cargando" color="primary" @click="crearProyecto">
              Continuar
            </v-btn>
          </div>
        </v-stepper-content>
        <!-- FIN PASO NUMERO 4 -->
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import Articulos from "./Articulos.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: { Articulos },
  data() {
    return {
      snackbar: false,
      mensajeSnackbar: "",
      colorSnack: "",

      paso: 1,

      //datos para enviar
      vendedorID:null,
      clienteSeleccionado: null,
      fechaSeleccionada: null,
      folio: "",
      articulos: [],
      archivoExcel: null,
      archivos: [],
      costoTotal: 0,
      factura: '',
      tipo:false,
      costo:null,
      venta:null,

      //Datos para validacion / mostrar informacion
      proveedores:[],
      vendedorSeleccionado: null,
      minFecha: "",
      modalFecha: false,
      clientes: [],
      imagenes: [],
      excel: [],
      pdf: [],
      word: [],
      def:[],

      extensionesImagenes: /(\.jpg|\.jpeg|\.png|\.gif)$/i,
      extensionesWord: /(\.docx|\.doc)$/i,
      extensionesExcel: /(\.xls|\.xlsx)$/i,
      extensionPDF: /(\.pdf)$/i,

      cargando: false,
      tiposProyecto: [
        {'TIPO':'PROYECTO', 'VALOR':'P'},
        {'TIPO':'SERVICIO', 'VALOR':'S'},
        ]
    };
  },

  computed: {
    ...mapGetters([
      "getUsuarioID",
      "getUsuario",
      "getFechaActual",
      "getURLAPI",
      "getNombreCompletoUsuario"
    ]),

    getCosto: function () {
      let costo = 0;
      for (let i = 0; i < this.articulos.length; i++) {
        costo += parseInt(this.articulos[i].COSTO);
      }
      return costo;
    }
  },

  methods: {
    // ------------------------------------------------------------------------------
    cortarString(string, tamaño) {
      return string.length > tamaño
        ? string.substring(0, tamaño) + "..."
        : string;
    },
    // ------------------------------------------------------------------------------
    async setClientes() {
      this.clientes = (
        await axios.get(`${this.getURLAPI}/Show/allClient`)
      ).data;
    },
    // ------------------------------------------------------------------------------
    setArticulos(articulos) {
      this.articulos = articulos;
      this.costoTotal = null;
      
      console.log(this.costoTotal);
      window.onbeforeunload = () => {
        return "¿Estas seguro que quieres recargar? \n Se Perderán todos los cambios.";
      };
    },
    // ------------------------------------------------------------------------------
    async getProveedores(){
      this.proveedores = (await axios.get(`${this.getURLAPI}/Show/allProveedores`)).data
      // console.log(this.proveedores);
    },
    // ------------------------------------------------------------------------------
    setArchivoExcel(excel) {
      this.archivoExcel = excel;
    },
    // ------------------------------------------------------------------------------
    agregarArchivo(archivos) {
      this.imagenes = [];
      this.excel = [];
      this.word = [];
      this.pdf = [];
      this.def = [];

      archivos.forEach((archivo) => {
        if (this.extensionesImagenes.exec(archivo.name)) {
          this.imagenes.push(URL.createObjectURL(archivo));
        } else if (this.extensionesExcel.exec(archivo.name)) {
          // Si es Excel
          console.log("Archivo Excel");
          this.excel.push(archivo);
        } else if (this.extensionesWord.exec(archivo.name)) {
          // Si es Word
          console.log("Archivo Word");
          this.word.push(archivo);
        } else if (this.extensionPDF.exec(archivo.name)) {
          // Si es PDF
          console.log("PDF");
          this.pdf.push(archivo);
        } else{
          this.def.push(archivo);
        }
      });
    },
    // ------------------------------------------------------------------------------
    crearProyecto() {
      if ( this.clienteSeleccionado != null && this.fechaSeleccionada && this.articulos.length > 0 ){
        this.cargando = true;
        let datosForm = new FormData();

        datosForm.append( "USUARIO_ID",         this.getUsuarioID);
        datosForm.append( "CLIENTE_ID",         parseInt(this.clienteSeleccionado.CLIENTE_ID));
        datosForm.append( "FOLIO",              this.folio.toUpperCase());
        datosForm.append( "FECHA_ENTREGA",      this.fechaSeleccionada);
        datosForm.append( "USUARIO_CREADOR",    this.getUsuario);
        datosForm.append( "FECHA_HORA_CREACION",this.getFechaActual);
        datosForm.append( "ARTICULOS",          JSON.stringify(this.articulos));
        datosForm.append( "VENTA",              this.venta);
        datosForm.append( "COSTO",              this.costo);
        {
          let dato;
          this.tipo ? dato = "S" : dato = "P";
          datosForm.append( "TIPO",               dato);
        }

        if(this.factura != '') {
          datosForm.append('FACTURA',       this.factura);
        }

        if( this.archivos.length > 0){
          for ( var arch of this.archivos ){
            datosForm.append('ARCHIVOS[]', arch, arch.name);
          }
        }
        if (this.archivoExcel != null) {
          datosForm.append("EXCELPRODUCTOS",   this.archivoExcel);
        }

        for (var value of datosForm.values()) {
          console.log(value);
        }
        // this.cargando = false;
        // console.log(datos);

        // SE MANDAN LOS DATOS A LA LIGA PARA CREAR EL PROYECTO
        axios.post(`${this.getURLAPI}/Proyecto/insert1`, datosForm, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(({ data }) => {
            console.log(data);
            if (data.STATUS == "OK") {
              this.cargando = false;
              this.$emit('ActualizarProyectos');
              // this.$emit('mostrarSnackbar', {snackbar:true,msg:data.MSG});
              this.$root.vtoast.show(
                { message: data.MSG,  color:data.STATUS=="OK" ? 'success darken-2':'red darken-2', 
                  timer:10000,        icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' } 
              )
              this.$emit('mostrar');
            } else {
              this.$root.vtoast.show(
                { message: data.MSG,  color:'red darken-2', 
                  timer:10000,        icon: 'mdi-alert-circle-outline' } 
              )
              // this.snackbar = true;
              // this.mensajeSnackbar = data.MSG;
              // this.colorSnack = "red lighten-1";
              this.cargando = false;
            }
          })
          .catch(() => {
            this.$root.vtoast.show(
                { message: "Error con el servidor",  color:'red darken-2', 
                  timer:10000,        icon: 'mdi-alert-circle-outline' } 
            )
            this.cargando = false;
          });
      } else {
        this.$root.vtoast.show(
                { message: "Verifica que se ingresaron todos los datos",  color:'black', 
                  timer:10000,        icon: 'mdi-alert-circle-outline' } 
        )
        this.cargando = false;
        // this.snackbar = true;
        // this.mensajeSnackbar = "Verifica que se ingresaron todos los datos";
      }
    },

    // ------------------------------------------------------------------------------
    cerrar() {
      let close = confirm("¿Seguro que quieres cancelar el proyecto?");
      if (close) {
        this.$emit("mostrar");
      }
    },
  },
  // ------------------------------------------------------------------------------
  created() {
    this.setClientes();
    this.vendedorSeleccionado = this.getNombreCompletoUsuario;
    this.vendedorID = this.getUsuarioID;
    this.minFecha = this.getFechaActual.split(" ");
    this.getProveedores();
    console.log(this.minFecha[0]);
    // this.tipo = 'P';
  },
};
</script>

<style scoped>
.tamanoLetra {
  font-size: small !important;
}

.alturaTexto {
  min-height: 120px;
}
.v-list-item__title, .v-list-item__subtitle {
  white-space: normal;
}
</style>
